import mitt from 'mitt';
import { simpleIdGenerator } from '@THC/utils/simpleIdGenerator';
const toastIdGenerator = simpleIdGenerator('thc-toast');
export const toastEmitter = mitt();
export const toast = (toastProps) => {
    const toastId = toastIdGenerator.next().value;
    toastEmitter.emit('add', { ...toastProps, __internal: { toastId } });
    return () => toastEmitter.emit('dismiss', { toastId });
};
